module.exports = __webpack_public_path__ + "img/no-records-my-team-actiivity.e2b2c988.png";